const article = {
    slug: "raf-simons",
    category: "BRAND BUYBACK",
    listTitle: "RAF SIMONS買取",
    listDescription:
      "宗教期・テロ期・Consumed・Virginia Creeperなどのアーカイブから、近年作・コラボレーションまで、RAF SIMONSの文脈と市場価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "RAF SIMONS買取｜ラフシモンズのアーカイブ価値まで査定するEnclopedia",
      description:
        "RAF SIMONS（ラフシモンズ）の買取ならEnclopediaへ。宗教期、テロ期、Consumed、Virginia Creeper、Riot Riot Riotなどの希少アーカイブから、コート、ニット、シャツ、スウェット、バッグ、スニーカー、コラボレーション品まで、シーズン背景・希少性・市場価値を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "RAF SIMONS 買取,ラフシモンズ 買取,RAF SIMONS 高価買取,ラフシモンズ 高価買取,RAF SIMONS 宅配買取,ラフシモンズ 宅配買取,RAF SIMONS LINE査定,ラフシモンズ 買取相場,RAF SIMONS アーカイブ 買取,ラフシモンズ アーカイブ 買取,RAF SIMONS 宗教期 買取,RAF SIMONS テロ期 買取,RAF SIMONS Consumed 買取,RAF SIMONS Virginia Creeper 買取,RAF SIMONS Riot Riot Riot 買取,RAF SIMONS Sterling Ruby 買取,RAF SIMONS Eastpak 買取,RAF SIMONS adidas 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/raf-simons",
    },
    hero: {
      label: "RAF SIMONS BUYBACK",
      number: "07 / BUYBACK",
      titleLines: [
        "RAF SIMONS買取。",
        "アーカイブの文脈まで見て査定します。",
      ],
      body:
        "Enclopediaは、RAF SIMONSをブランド名や相場だけで一律に判断しません。\n宗教期、テロ期、Consumed、Virginia Creeper、Riot Riot Riotなどのアーカイブ性、グラフィックの希少性、シーズン背景、現在の市場需要まで確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "raf simons buyback",
        "archive valuation",
        "youth culture",
        "collection rarity",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "相場だけではなく、",
        "時代性と熱量まで見る。",
      ],
      image: "media/archive_fashion/buyback7.png",
      imageAlt: "RAF SIMONS買取のメイン画像",
    },
    thesis: {
      text:
        "RAF SIMONSの価値は、ブランド名ではなく、シーズン背景・グラフィック・希少性・カルチャー性まで見て判断する。",
      keywords: ["season", "graphic", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "RAF SIMONSの価値は、",
        "“古着の相場”だけでは測れない。",
      ],
      body:
        "RAF SIMONSは、ユースカルチャー、音楽、アート、反抗性、テーラリングを結びつけ、メンズファッションの見え方を大きく変えてきたブランドです。\n同じRAF SIMONSでも、初期アーカイブ、グラフィックアイテム、テーラード、ニット、コラボレーション、近年作では評価軸が異なります。\nEnclopediaでは、単に人気モデルかどうかではなく、その一着がどのシーズンに属し、どのような文脈と希少性を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "シーズン背景を見る",
          text:
            "宗教期、テロ期、Consumed、Virginia Creeper、Riot Riot Riotなど、シーズンごとの評価軸やコレクション文脈を確認します。",
        },
        {
          number: "02",
          title: "グラフィックと象徴性を見る",
          text:
            "プリント、パッチ、スローガン、アートワーク、シルエットなど、そのアイテムがRAF SIMONSらしさをどの程度示しているかを見ます。",
        },
        {
          number: "03",
          title: "希少性と現在需要を見る",
          text:
            "流通量、サイズ、状態、国内外の需要、再入手難度を踏まえ、型番相場だけで終わらせず個別に判断します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "RAF SIMONS全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "初期・名作シーズンのアーカイブ",
          text:
            "90年代後半から2000年代の希少アーカイブ、宗教期、テロ期、Consumed、Virginia Creeperなどの重要ピースを丁寧に査定します。",
        },
        {
          tag: "ITEM 02",
          title: "グラフィックTシャツ・スウェット",
          text:
            "RAF SIMONSを象徴するプリント、パッチ、スローガン、フォトグラフィックな表現があるアイテムを確認します。",
        },
        {
          tag: "ITEM 03",
          title: "ニット・オーバーサイズトップス",
          text:
            "ビッグシルエット、ダメージ加工、パッチワーク、グラフィック性の強いニットやセーターを査定します。",
        },
        {
          tag: "ITEM 04",
          title: "コート・ジャケット・テーラード",
          text:
            "モッズコート、ボンバージャケット、テーラードジャケット、ロングコートなど、シルエットとシーズン性を見て判断します。",
        },
        {
          tag: "ITEM 05",
          title: "シャツ・パンツ・セットアップ",
          text:
            "RAF SIMONSらしい細身・オーバーサイズ・制服的なムードを持つシャツやパンツ、セットアップも対象です。",
        },
        {
          tag: "ITEM 06",
          title: "Sterling Ruby・アート系コラボ",
          text:
            "RAF SIMONS × Sterling Rubyなど、アート文脈を持つ協業品は、通常ラインとは異なる評価軸で確認します。",
        },
        {
          tag: "ITEM 07",
          title: "Eastpak・adidas・Dr. Martens等のコラボ",
          text:
            "バッグ、スニーカー、ブーツなどのコラボレーション品も、型・状態・現在需要を踏まえて査定します。",
        },
        {
          tag: "ITEM 08",
          title: "近年作・終了前後のコレクション",
          text:
            "近年の人気シーズンやブランド終了前後の作品も、需要と希少性を確認して個別に評価します。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "RAF SIMONSのアイテム。",
      ],
      intro:
        "査定額は状態や相場で変動しますが、Enclopediaでは特に以下のようなRAF SIMONSを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "宗教期・テロ期・Consumedなどの希少アーカイブ",
          text:
            "RAF SIMONSの歴史の中でも評価されやすいシーズンの作品は、年代・状態・流通量・国内外需要を踏まえて個別に見ます。",
        },
        {
          index: "02",
          title: "強いグラフィックやスローガンを持つアイテム",
          text:
            "Tシャツ、スウェット、ニット、コートなど、視覚的な象徴性が強いピースは、単なる古着ではなくコレクション性を確認します。",
        },
        {
          index: "03",
          title: "ランウェイ性の高いコート・ジャケット・ニット",
          text:
            "シーズンテーマを担うシルエット、加工、素材使いのあるアイテムは、RAF SIMONSらしさとして査定に反映します。",
        },
        {
          index: "04",
          title: "Sterling RubyやEastpakなどのコラボレーション",
          text:
            "相手ブランドやアーティストの文脈、発売時期、現在の市場需要を確認し、通常ラインとは分けて評価します。",
        },
        {
          index: "05",
          title: "状態良好な希少サイズ・付属品完備品",
          text:
            "アーカイブ品はコンディション差が価格に影響しやすいため、保存状態、タグ、付属品、サイズ需要まで見て判断します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“高いブランド”としてではなく、",
        "時代をまとった服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいRAF SIMONSの価値。",
      ],
      intro:
        "RAF SIMONSは、年代・シーズン・グラフィック・カルチャー背景によって評価が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "古いRAF SIMONSを一括で見ない",
          text:
            "アーカイブと呼ばれる年代でも、シーズンやアイテム内容によって需要は大きく異なります。単に古いかどうかではなく、作品性を確認します。",
        },
        {
          index: "02",
          title: "プリントやパッチを“柄”として片付けない",
          text:
            "RAF SIMONSのグラフィックは、シーズンテーマやカルチャー性と結びつくことがあります。視覚的な強さと文脈を見ます。",
        },
        {
          index: "03",
          title: "国内外のアーカイブ需要を踏まえる",
          text:
            "RAF SIMONSは海外評価も強いブランドです。日本国内の相場だけでなく、現在の再流通需要まで含めて査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。全体、ブランドタグ、品番タグ、プリントやパッチ、ダメージ箇所が分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいRAF SIMONS買取。",
      ],
      intro:
        "LINEで相談してから進められるため、アーカイブ品や相場が分かりにくいアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、希少アーカイブも査定可否や方向性を事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "RAF SIMONS買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのRAF SIMONSアイテムを買取していますか？",
          answer:
            "ジャケット、コート、ニット、シャツ、Tシャツ、スウェット、パンツ、バッグ、スニーカー、ブーツ、コラボレーション品まで幅広くご相談いただけます。",
        },
        {
          question:
            "宗教期・テロ期・Consumedなどのアーカイブも査定できますか？",
          answer:
            "はい。RAF SIMONSの重要シーズンや希少アーカイブは、年代・状態・流通量・現在需要を確認して個別に査定します。",
        },
        {
          question:
            "古いRAF SIMONSほど高く買い取ってもらえますか？",
          answer:
            "年代だけで一律には判断しません。古い作品でも需要や希少性が高いものは評価されやすい一方、近年作でも人気モデルや状態の良い品は高値につながる場合があります。",
        },
        {
          question:
            "グラフィックTシャツやスウェットも買取対象ですか？",
          answer:
            "はい。RAF SIMONSらしいプリント、パッチ、スローガン、シーズン性のあるアイテムは丁寧に確認します。",
        },
        {
          question:
            "Sterling RubyやEastpakなどのコラボ品も査定できますか？",
          answer:
            "はい。コラボレーション背景、発売時期、状態、現在の市場需要を踏まえて個別に評価します。",
        },
        {
          question:
            "RAF SIMONSの買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。シーズン、品番、状態、需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "RAF SIMONSの価値をご相談ください。",
      ],
      body:
        "希少アーカイブ、グラフィック、コラボレーション、近年作まで確認。\nEnclopediaが、服の背景と再流通価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
